'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.then((registration) => {
            console.log('[SW] Registered, scope:', registration?.scope);

            // Check for updates every 60 minutes
            setInterval(() => registration?.update(), 60 * 60 * 1000);

            registration?.addEventListener('updatefound', () => {
              const newWorker = registration?.installing;
              if (!newWorker) return;
              newWorker?.addEventListener('statechange', () => {
                if (
                  newWorker?.state === 'installed' &&
                  navigator.serviceWorker?.controller
                ) {
                  // New content available — activate immediately
                  newWorker?.postMessage({ type: 'SKIP_WAITING' });
                }
              });
            });
          })?.catch((err) => console.warn('[SW] Registration failed:', err));
      });
    }
  }, []);

  return null;
}
